import GuestLayout from '../../Layouts/GuestLayout';
import LoginBox from '../../Components/LoginBox';
import InputLabel from '../../Components/InputLabel';
import TextInput from '../../Components/TextInput';
import InputError from '../../Components/InputError';
import AuthButton from '../../Components/AuthButton';
import { Head, Link, useForm } from '@inertiajs/react';

export default function ForgotPassword({ status }) {
    const { data, setData, post, processing, errors } = useForm({
        email: '',
    });

    const submit = (e) => {
        e.preventDefault();

        post(route('password.restore'));
    };

    return (
        <GuestLayout>
            <Head title="Forgot Password" />

            <LoginBox>
                <div className="w-full px-6 py-3 drop-shadow-md">

                    <div>
                        <div className="mt-4 text-left lg:mt-2">
                            <div className="inline-flex items-center w-full">
                                <p className="mb-4 text-sm text-slate-500">
                                    <span className="mr-1 text-slate-700">Forgot your password? </span>
                                    No problem. Just let us know your email address and we will email you a password
                                    reset link that will allow you to choose a new one.
                                </p>
                            </div>
                            <div className="mt-4 text-base text-slate-500">
                                {status && <p className="mb-4 font-medium text-sm text-green-600">{status}</p>}
                            </div>
                        </div>
                    </div>

                    <form onSubmit={submit}>
                        <div className="mt-6 space-y-4">
                            <div>
                                <InputLabel className="sr-only" htmlFor="email" value="Email" />

                                <TextInput
                                    id="email"
                                    type="email"
                                    name="email"
                                    value={data.email}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Enter your email"
                                    autoComplete="email"
                                    isFocused={true}
                                    onChange={(e) => setData('email', e.target.value)}
                                />

                                <InputError message={errors.email} className="mt-2" />

                            </div>

                            <div className="flex flex-col mt-4 lg:space-y-4">
                                <AuthButton disabled={processing}>
                                    Send Reset Link
                                </AuthButton>

                                <span className="mx-auto">
                                        <Link
                                            href={route('signin')}
                                            className="underline text-sm inline-flex justify-center py-4 font-medium text-slate-500 focus:outline-none hover:text-neutral-600 focus:text-slate-600 sm:text-sm"
                                        >
                                            Back to login
                                        </Link>
                                </span>
                            </div>
                        </div>
                    </form>

                </div>

            </LoginBox>

        </GuestLayout>
    );
}
